module.exports = __webpack_public_path__ + "img/Icon - Students.2086c578.svg";